import { render } from "./About-Us.vue?vue&type=template&id=fb4d4602&scoped=true"
import script from "./About-Us.vue?vue&type=script&lang=js"
export * from "./About-Us.vue?vue&type=script&lang=js"

import "./About-Us.vue?vue&type=style&index=0&id=fb4d4602&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4d4602"]])

export default __exports__